/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum Type {
  Variable = "Variable",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum FunctionName {
  Contains = "contains",
}

export enum ServerType {
  FTP = "FTP",
  SFTP = "SFTP",
}

export enum ServerEnvironmentType {
  TEST = "TEST",
  PRODUCTION = "PRODUCTION",
}

export enum BarcodeFormat {
  AZTEC = "AZTEC",
  CODABAR = "CODABAR",
  CODE_39 = "CODE_39",
  CODE_93 = "CODE_93",
  CODE_128 = "CODE_128",
  DATA_MATRIX = "DATA_MATRIX",
  EAN_8 = "EAN_8",
  EAN_13 = "EAN_13",
  ITF = "ITF",
  MAXICODE = "MAXICODE",
  PDF_417 = "PDF_417",
  QR_CODE = "QR_CODE",
  RSS_14 = "RSS_14",
  RSS_EXPANDED = "RSS_EXPANDED",
  UPC_A = "UPC_A",
  UPC_E = "UPC_E",
  UPC_EAN_EXTENSION = "UPC_EAN_EXTENSION",
}

export enum CommissionRequestStatus {
  VALID = "VALID",
  MULTIPLE_SUPPLIER_CONDITIONS = "MULTIPLE_SUPPLIER_CONDITIONS",
  NO_SUPPLIER_CONDITION = "NO_SUPPLIER_CONDITION",
}

export enum StatusMessageType {
  INFO = "INFO",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export enum ReportType {
  REQUEST = "REQUEST",
  ORDER = "ORDER",
  STOCK = "STOCK",
  SALE = "SALE",
}

export enum ReportFileType {
  CSV = "CSV",
  EXCEL = "EXCEL",
}

export enum FileType {
  JPEG = "JPEG",
  PNG = "PNG",
  PDF = "PDF",
}

export enum Status {
  OK = "OK",
  FAIL = "FAIL",
}

export enum ModuleType {
  SHOPPING_CART = "SHOPPING_CART",
}

export interface ResponseObject {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: object;
  requestId?: string;
}

export interface MenuBatchDto {
  inventoryActive?: boolean;
  bmecatActive?: boolean;
  /** @format int32 */
  requestImportCount?: number;
  /** @format int32 */
  importProblemCount?: number;
  /** @format int32 */
  delayedRequestPositionCount?: number;
  /** @format int32 */
  unrequiredRequestCount?: number;
  /** @format int32 */
  requiredStockCount?: number;
  /** @format int32 */
  unorderedOrderCount?: number;
  /** @format int32 */
  orderConfirmationCount?: number;
  /** @format int32 */
  unbookedDeliveryNotes?: number;
  /** @format int32 */
  expectedGoodsReceiptCount?: number;
  /** @format int32 */
  unextractedRequestCount?: number;
  /** @format int32 */
  bmecatReady?: number;
  /** @format int32 */
  shoppingCartCount?: number;
}

export interface ResponseMenuBatchDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: MenuBatchDto;
  requestId?: string;
}

export interface ReleaseDto {
  releaseGuid?: string;
  version?: string;
  /** @format int64 */
  releaseDate?: number;
}

export interface ResponseReleaseDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ReleaseDto;
  requestId?: string;
}

export interface ResponseString {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: string;
  requestId?: string;
}

export interface ReleaseTextDto {
  releaseGuid?: string;
  text?: string;
}

export interface ResponseListReleaseTextDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ReleaseTextDto[];
  requestId?: string;
}

export interface ResponseBoolean {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: boolean;
  requestId?: string;
}

export interface CheckEmailAndUserNameRequest {
  userName?: string;
  email?: string;
}

export interface CreateNewUserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  password?: string;
  isEmailCCEnabled?: boolean;
}

export interface Client {
  guid?: string;
  ciamSub?: string;
  name?: string;
  street?: string;
  zip?: string;
  city?: string;
  country?: string;
  phone?: string;
  fax?: string;
  email?: string;
  isDeliveryTimeChangeable?: boolean;
  selected?: boolean;
}

export interface ResponseListClient {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: Client[];
  requestId?: string;
}

export interface ModuleDto {
  moduleType?: ModuleType;
  enabled?: boolean;
}

export interface ResponseUserDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: UserDto;
  requestId?: string;
}

export interface UserDto {
  guid?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  language?: string;
  viewConfig?: string;
  isEmailCCEnabled?: boolean;
  isCiamUser?: boolean;
  name?: string;
  administrator?: boolean;
  clientAdministrator?: boolean;
  editor?: boolean;
  installer?: boolean;
  modules?: ModuleDto[];
}

export interface ResponseListString {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: string[];
  requestId?: string;
}

export interface ClientRequest {
  clientGuid?: string;
}

export interface UserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  language?: string;
  isEmailCCEnabled?: boolean;
}

export interface UpdatePasswordRequest {
  oldPassword?: string;
  newPassword?: string;
  confirmNewPassword?: string;
}

export interface UpdateRolesRequest {
  userGuid?: string;
  roleNames?: string[];
}

export interface Context {
  conditions?: Record<string, object>;
  sorters?: Record<string, object>;
  filters?: Record<string, object>;
  width?: Record<string, string>;
  states?: Record<string, Record<string, object>[]>;
  isDefault?: boolean;
}

export interface UpdateViewConfigRequest {
  viewConfig?: Record<string, View[]>;
}

export interface View {
  title?: string;
  key?: string;
  favorite?: boolean;
  changeable?: boolean;
  remove?: boolean;
  contexts?: Context;
}

export interface ArticleFilterResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  productGroup?: boolean;
  materialGroup?: boolean;
}

export interface ArticleSupplier {
  supplierGuid?: string;
  supplierName?: string;
}

export interface ResponseListArticleSupplier {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ArticleSupplier[];
  requestId?: string;
}

export interface ProductCategoryMappingResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  articleGuid?: string;
  productCategoryGuids?: string[];
}

export interface ProductCategoryMappingRequest {
  articleGuid?: string;
  productCategoryGuids?: string[];
}

export interface BaseResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
}

export interface ActivationDataFlavor {
  mimeType?: string;
  humanPresentableName?: string;
}

export interface Attachment {
  headers?: {
    empty?: boolean;
    [key: string]: any;
  };
  object?: object;
  contentType?: MediaType;
  contentDisposition?: ContentDisposition;
  dataHandler?: DataHandler;
  contentId?: string;
}

export interface CommandInfo {
  commandName?: string;
  commandClass?: string;
}

export interface CommandMap {
  mimeTypes?: string[];
}

export interface ContentDisposition {
  type?: string;
  parameters?: Record<string, string>;
  filename?: string;
}

export interface DataHandler {
  commandMap?: CommandMap;
  contentType?: string;
  outputStream?: object;
  name?: string;
  inputStream?: object;
  content?: object;
  transferDataFlavors?: ActivationDataFlavor[];
  preferredCommands?: CommandInfo[];
  allCommands?: CommandInfo[];
  dataSource?: DataSource;
}

export interface DataSource {
  contentType?: string;
  outputStream?: object;
  name?: string;
  inputStream?: object;
}

export interface MediaType {
  type?: string;
  subtype?: string;
  parameters?: Record<string, string>;
  wildcardSubtype?: boolean;
  wildcardType?: boolean;
}

export interface MultivaluedMapStringString {
  empty?: boolean;
  [key: string]: any;
}

export interface OrderFileDto {
  guid?: string;
  orderGuid?: string;
  name?: string;
  /** @format int32 */
  bytes?: number;
  fileType?: FileType;
}

export interface ResponseListOrderFileDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: OrderFileDto[];
  requestId?: string;
}

export interface OrderFile {
  guid?: string;
  orderGuid?: string;
  name?: string;
  /** @format int32 */
  bytes?: number;
  fileType?: FileType;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  updatedOn?: string;
  /** @format date-time */
  deletedOn?: string;
  createdByUserGuid?: string;
  updatedByUserGuid?: string;
  deletedByUserGuid?: string;
  deleted?: boolean;
}

export interface ResponseLong {
  additionalInfo?: Record<string, object>[];
  message?: string;
  /** @format int64 */
  content?: number;
  requestId?: string;
}

export interface AssignToSupplierRequest {
  orderPositionGuid?: string;
  supplierConditionGuid?: string;
  assignAsDefault?: boolean;
}

export interface CancelResidualRequest {
  orderPositionGuids?: string[];
}

export interface GoodsReceiptRequest {
  orderPositionGuid?: string;
  /** @format int32 */
  pieces?: number;
  /** @format double */
  amount?: number;
  deliveryNotes?: Record<string, number>;
}

export interface OrderRequest {
  orderGuid?: string;
}

export interface MarkAsIgnored {
  guids?: string[];
  reason?: string;
}

export interface ProductConfiguration {
  guid?: string;
  name?: string;
  articleGuid?: string;
  supplierTemplateGuid?: string;
  innerLaminationGuid?: string;
  outerLaminationGuid?: string;
  carrierGuid?: string;
  geometryGuid?: string;
  sealGuid?: string;
  sealColorGuid?: string;
  additionalEquipmentGuid?: string;
  isNameManuallySet?: boolean;
  isStockManaged?: boolean;
  isCommissionArticle?: boolean;
  /** @format double */
  baseAmount?: number;
  baseUnitGuid?: string;
  ean?: string;
  /** @format double */
  offcut?: number;
}

export interface ProductTemplateConfiguration {
  /** @format double */
  baseAmount?: number;
  defaultBaseUnit?: SupplierConditionProperty;
  baseUnits?: SupplierConditionProperty[];
  defaultOuterLamination?: SupplierConditionProperty;
  outerLaminations?: SupplierConditionProperty[];
  defaultInnerLamination?: SupplierConditionProperty;
  innerLaminations?: SupplierConditionProperty[];
  defaultCarrier?: SupplierConditionProperty;
  carriers?: SupplierConditionProperty[];
  defaultGeometry?: SupplierConditionProperty;
  geometries?: SupplierConditionProperty[];
  defaultSeal?: SupplierConditionProperty;
  seals?: SupplierConditionProperty[];
  defaultSealColor?: SupplierConditionProperty;
  sealColors?: SupplierConditionProperty[];
  defaultAdditionalEquipment?: SupplierConditionProperty;
  additionalEquipments?: SupplierConditionProperty[];
}

export interface ResponseProductTemplateConfiguration {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ProductTemplateConfiguration;
  requestId?: string;
}

export interface SupplierConditionProperty {
  guid?: string;
  displayName?: string;
  name?: string;
  creationType?: string;
  decimalValue?: boolean;
  number?: string;
}

export interface DefaultSupplierDto {
  guid?: string;
  supplierGuid?: string;
  supplierName?: string;
  /** @format int32 */
  deliveryTime?: number;
}

export interface ResponseDefaultSupplierDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: DefaultSupplierDto;
  requestId?: string;
}

export interface ProductVariantConfigurationDto {
  guid?: string;
  innerLamination?: PropertyDto;
  outerLamination?: PropertyDto;
  carrier?: PropertyDto;
  geometry?: PropertyDto;
  seal?: PropertyDto;
  sealColor?: PropertyDto;
  additionalEquipment?: PropertyDto;
}

export interface PropertyDto {
  guid?: string;
  name?: string;
  number?: string;
}

export interface ResponseProductVariantConfigurationDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ProductVariantConfigurationDto;
  requestId?: string;
}

export interface ProductDeletionResult {
  deletedProducts?: string[];
  requiredProducts?: string[];
  currentStep?: string;
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  totalEntries?: number;
}

export interface ResponseProductDeletionResult {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ProductDeletionResult;
  requestId?: string;
}

export interface ProcessStatus {
  currentStep?: string;
  /** @format int32 */
  changedEntries?: number;
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  totalEntries?: number;
}

export interface ResponseProcessStatus {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ProcessStatus;
  requestId?: string;
}

export interface CreateReportRequest {
  reportType?: ReportType;
  sorterType?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  fileType?: ReportFileType;
}

export interface BaseProgressResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  currentStep?: string;
  /** @format int32 */
  currentStepCount?: number;
  /** @format int32 */
  maxStepCount?: number;
  /** @format double */
  stepPercentage?: number;
  /** @format double */
  overallPercentage?: number;
}

export interface ResponseBaseProgressResponse {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: BaseProgressResponse;
  requestId?: string;
}

export interface CancelRequestsRequest {
  requestGuids?: string[];
}

export interface CreateRequirementRequest {
  requestGuids?: string[];
}

export interface ExtractedPositionsStatus {
  completeExtracted?: boolean;
}

export interface ResponseExtractedPositionsStatus {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ExtractedPositionsStatus;
  requestId?: string;
}

export interface RequestPositionExtractionRequest {
  requestPositionGuids?: string[];
  allowNegative?: boolean;
}

export interface ResponseStatusMessage {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: StatusMessage;
  requestId?: string;
}

export interface StatusMessage {
  message?: string;
  type?: StatusMessageType;
}

export interface RequestExtractionRequest {
  requestGuids?: string[];
  allowNegative?: boolean;
}

export interface RequestToSupplierCon {
  materialGroupName?: string;
  materialGroupGuid?: string;
  supplierGuid?: string;
  supplierName?: string;
  articleName?: string;
  articleNumber?: string;
  articleGuid?: string;
  productGuid?: string;
  productName?: string;
  baseUnitName?: string;
  baseUnitGuid?: string;
}

export interface ResponseListRequestToSupplierCon {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: RequestToSupplierCon[];
  requestId?: string;
}

export interface DelayedRequestPositionDto {
  guid?: string;
  articleName?: string;
  articleNumber?: string;
  variantName?: string;
  /** @format double */
  baseAmount?: number;
  baseUnitGuid?: string;
  baseUnitName?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  reservedAmount?: number;
  /** @format date-time */
  productionDate?: string;
  requestGuid?: string;
  requestNumber?: string;
  customerGuid?: string;
  customerName?: string;
  /** @format int32 */
  deliveryTime?: number;
  /** @format int32 */
  orderPeriod?: number;
  /** @format int32 */
  criticalOrderPeriod?: number;
  /** @format date-time */
  lastOrderDate?: string;
  /** @format date-time */
  possibleDelivery?: string;
}

export interface ResponseListDelayedRequestPositionDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: DelayedRequestPositionDto[];
  requestId?: string;
}

export interface RequirementStatusDto {
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  totalStepEntries?: number;
  /** @format int32 */
  currentSubEntry?: number;
  /** @format int32 */
  totalSubEntries?: number;
  currentStep?: string;
  /** @format int32 */
  currentStepCount?: number;
  /** @format int32 */
  maxStepCount?: number;
  /** @format double */
  stepPercentage?: number;
  /** @format double */
  overallPercentage?: number;
}

export interface ResponseRequirementStatusDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: RequirementStatusDto;
  requestId?: string;
}

export interface ResponseCommissionRequestStatus {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: CommissionRequestStatus;
  requestId?: string;
}

export interface AssumeToOrderDto {
  created?: Record<string, string[]>;
  added?: Record<string, string[]>;
  error?: string[];
}

export interface ResponseAssumeToOrderDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: AssumeToOrderDto;
  requestId?: string;
}

export interface ContactDto {
  email?: string;
  name?: string;
}

export interface ResponseContactDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ContactDto;
  requestId?: string;
}

export interface ResponseStockExtractionResultDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: StockExtractionResultDto;
  requestId?: string;
}

export interface StockExtractionResultDto {
  uncoveredPositions?: UncoveredStockPositionDto[];
  fullyCovered?: boolean;
}

export interface UncoveredStockPositionDto {
  productGuid?: string;
  productName?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  currentStock?: number;
}

export interface ResponseBaseResponse {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: BaseResponse;
  requestId?: string;
}

export interface InventorySettingsResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  inventoryActive?: boolean;
  inventoryInterrupted?: boolean;
  /** @format date-time */
  lastInventoryDate?: string;
}

export interface ResponseInventorySettingsResponse {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: InventorySettingsResponse;
  requestId?: string;
}

export interface FinishInventoryStatus {
  currentStep?: string;
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  maxEntries?: number;
  running?: boolean;
}

export interface ResponseFinishInventoryStatus {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: FinishInventoryStatus;
  requestId?: string;
}

export interface StartInventoryRequest {
  resetAll?: boolean;
  categoryGuids?: string[];
}

export interface CreateRequirementOrdersRequest {
  all?: boolean;
  supplierConditionGuid?: string;
  productGuids?: string[];
}

export interface CreateBarcodeRequest {
  content?: string;
  type?: BarcodeFormat;
  format?: string;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface ChartRequest {
  /** @format int64 */
  startDate?: number;
  /** @format int64 */
  endDate?: number;
  productGuid?: string;
}

export interface ResponseStockValueDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: StockValueDto;
  requestId?: string;
}

export interface StockValueDto {
  guid?: string;
  /** @format double */
  dailyStockAmount?: number;
  /** @format double */
  dailyReservedAmount?: number;
  /** @format double */
  dailyRequiredOrderAmount?: number;
  /** @format double */
  requiredOrderAmount?: number;
  /** @format double */
  fictiveStock?: number;
  /** @format double */
  fictiveDayStock?: number;
  /** @format double */
  openDeliverAmount?: number;
  /** @format double */
  openOrderedAmount?: number;
}

export interface ImportStockResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  /** @format int32 */
  succeedCount?: number;
  /** @format int32 */
  failedCount?: number;
  excelFileGuid?: string;
}

export interface UpdateProductMappingRequest {
  productGuid?: string;
  stockLocationGuids?: string[];
}

export interface ResetStockStatus {
  currentStep?: string;
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  maxEntries?: number;
  running?: boolean;
}

export interface ResponseResetStockStatus {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ResetStockStatus;
  requestId?: string;
}

export interface ResetStockRequest {
  /** @format int64 */
  resetTimestamp?: number;
  clientGuid?: string;
}

export interface ResponseDouble {
  additionalInfo?: Record<string, object>[];
  message?: string;
  /** @format double */
  content?: number;
  requestId?: string;
}

export interface UpdateStockRequest {
  productGuid?: string;
  /** @format double */
  pieceIn?: number;
  /** @format double */
  pieceOut?: number;
  /** @format double */
  newStock?: number;
  /** @format double */
  minStock?: number;
}

export interface PackingUnitDto {
  guid?: string;
  packingUnitName?: string;
  /** @format double */
  baseAmount?: number;
  baseUnitName?: string;
  /** @format double */
  units?: number;
  /** @format double */
  singleAmount?: number;
  supplierArticleNumber?: string;
  /** @format int32 */
  unitDivider?: number;
  unitDividerUnitName?: string;
  /** @format int32 */
  defaultOrderAmount?: number;
  defaultUnitName?: string;
  /** @format double */
  minOrderAmount?: number;
  minOrderUnitName?: string;
}

export interface ResponseListPackingUnitDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: PackingUnitDto[];
  requestId?: string;
}

export interface DeleteSupplierConditionRequest {
  guid?: string;
  productGuid?: string;
}

export interface ResponseSupplierServerConfigurationDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: SupplierServerConfigurationDto;
  requestId?: string;
}

export interface SupplierServerConfigurationDto {
  guid?: string;
  serverType?: ServerType;
  environmentType?: ServerEnvironmentType;
  serverUri?: string;
  username?: string;
  password?: string;
  inboundPath?: string;
  outboundPath?: string;
  enabled?: boolean;
  /** @format int32 */
  retryCount?: number;
  /** @format date-time */
  lastConnection?: string;
  /** @format date-time */
  lastConnectionAttempt?: string;
}

export interface SupplierServerConfigurationRequest {
  serverType?: ServerType;
  environmentType?: ServerEnvironmentType;
  serverUri?: string;
  username?: string;
  password?: string;
  inboundPath?: string;
  outboundPath?: string;
  enabled?: boolean;
  description?: string;
}

export interface GlobalOrderPeriod {
  guid?: string;
  /** @format int32 */
  days?: number;
  /** @format date-time */
  fromDate?: string;
  /** @format date-time */
  tillDate?: string;
}

export interface ResponseGlobalOrderPeriod {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: GlobalOrderPeriod;
  requestId?: string;
}

export interface OrderPeriodOverrideRequest {
  /** @format int32 */
  days?: number;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface ExcelStartResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  guid?: string;
}

export interface FilterNode {
  type?: Type;
  left?: FilterNode;
  right?: FilterNode;
  op?: string;
  name?: FunctionName;
  args?: FilterNode[];
  path?: string;
  value?: object;
  ref?: FilterNode;
  variable?: FilterVariable;
  condition?: FilterNode;
}

export interface FilterVariable {
  type?: Type;
  name?: string;
}

export interface OrderExcelRequest {
  orderField?: string;
  orderDirection?: OrderDirection;
  filter?: FilterNode;
  includeRequestNumbers?: boolean;
}

export interface ExcelStatusResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  currentStep?: string;
  /** @format int32 */
  currentStepCount?: number;
  /** @format int32 */
  maxStepCount?: number;
  /** @format double */
  currentStepProgress?: number;
}

export interface OrderPositionExcelRequest {
  orderField?: string;
  orderDirection?: OrderDirection;
  filter?: FilterNode;
  /** @format int32 */
  interval?: number;
  includeRequestNumbers?: boolean;
}

export interface StockReportRequest {
  orderField?: string;
  orderDirection?: OrderDirection;
  filter?: FilterNode;
  includePriceData?: boolean;
}

export interface PdfStatusDto {
  currentStep?: string;
  /** @format int32 */
  currentStepCount?: number;
  /** @format int32 */
  maxStepCount?: number;
  /** @format double */
  currentStepProgress?: number;
}

export interface ResponsePdfStatusDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: PdfStatusDto;
  requestId?: string;
}

export interface BaseFilterRequest {
  orderField?: string;
  orderDirection?: OrderDirection;
  filter?: FilterNode;
}

export interface OrderNumberInvoiceRequest {
  orderGuid?: string;
  includePrice?: boolean;
  isPreview?: boolean;
}

export interface RequestNumberInvoiceRequest {
  requestGuid?: string;
  isStock?: boolean;
}

export interface DownloadSingleRequestDto {
  guid?: string;
}

export interface DownloadMultipleRequestDto {
  guids?: string[];
}

export interface ImportDataDto {
  importProblemGuid?: string;
  productGuid?: string;
}

export interface KlaesMissingTokens {
  supplierToken?: string;
}

export interface ResponseListKlaesMissingTokens {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: KlaesMissingTokens[];
  requestId?: string;
}

export interface ImportStatusDto {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  currentStep?: string;
  /** @format int32 */
  currentStepCount?: number;
  /** @format int32 */
  maxStepCount?: number;
  /** @format double */
  stepPercentage?: number;
  /** @format double */
  overallPercentage?: number;
  /** @format int32 */
  currentEntry?: number;
  /** @format int32 */
  totalStepEntries?: number;
  exceptions?: boolean;
  warnings?: boolean;
}

export interface ResponseImportStatusDto {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: ImportStatusDto;
  requestId?: string;
}

export interface RequestImportRequest {
  requestIds?: string[];
}

export interface RequestImportResult {
  requestId?: string;
  status?: string;
  exceptions?: string[];
  warnings?: RequestImportWarning[];
  hasImportProblems?: boolean;
}

export interface RequestImportWarning {
  fileName?: string;
  warningList?: string[];
}

export interface ResponseListRequestImportResult {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: RequestImportResult[];
  requestId?: string;
}

export interface RequestAvailabilityResponse {
  status?: Status;
  errorCode?: string;
  message?: string;
  responseEntity?: object;
  requestId?: string;
  customerNumber?: string;
  customerName?: string;
  customerFirstName?: string;
  customerAddress?: string;
  exportDate?: string;
  imported?: boolean;
  importable?: boolean;
  requirementMade?: boolean;
}

export interface ResponseListRequestAvailabilityResponse {
  additionalInfo?: Record<string, object>[];
  message?: string;
  content?: RequestAvailabilityResponse[];
  requestId?: string;
}
